import { render, staticRenderFns } from "./ClicTextArea.vue?vue&type=template&id=50b43be9&"
import script from "./ClicTextArea.vue?vue&type=script&lang=js&"
export * from "./ClicTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports